<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  infoText: {
    type: String,
    default: '',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tone: {
    type: String,
    default: 'default',
    validator: value =>
      ['default', 'brand', 'success', 'danger'].includes(value),
  },
});

const valueClass = computed(() => {
  const classes = {
    default: 'text-n-slate-12',
    brand: 'text-n-brand',
    success: 'text-n-teal-11',
    danger: 'text-n-ruby-11',
  };

  return classes[props.tone];
});
</script>

<template>
  <div
    data-test-id="reportMetricContainer"
    class="bg-n-solid-3 rounded-lg p-4 min-h-[5.75rem]"
    :class="{
      'grayscale pointer-events-none opacity-30': disabled,
    }"
  >
    <h3 class="flex items-center m-0 text-sm font-medium text-n-slate-11">
      <span data-test-id="reportMetricLabel">{{ label }}</span>
      <fluent-icon
        v-if="infoText"
        v-tooltip="infoText"
        data-test-id="reportMetricInfo"
        size="14"
        icon="info"
        class="text-n-slate-11 my-0 mx-1 mt-0.5"
      />
    </h3>
    <div
      v-if="isLoading"
      class="w-16 h-8 mt-2 rounded-md bg-n-slate-3 animate-pulse"
    />
    <h4
      v-else
      data-test-id="reportMetricValue"
      class="mt-3 mb-0 text-2xl font-semibold"
      :class="valueClass"
    >
      {{ value }}
    </h4>
  </div>
</template>
